// minimal IndexedDB wrapper for storing photos on device.
const DB_NAME = 'bingo';
const STORE = 'photos';

let dbPromise;

/**
 * Open the database once and reuse the connection.
 */
function openDb() {
    dbPromise ??= new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, 1);

        // runs only the first time (or when the version number goes up)
        request.onupgradeneeded = () => request.result.createObjectStore(STORE);

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
    return dbPromise;
}

/**
 * Run a single request inside a transaction and wait until it is committed.
 */
async function run(mode, callback) {
    const db = await openDb();

    return new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE, mode);
        const request = callback(transaction.objectStore(STORE));

        transaction.oncomplete = () => resolve(request?.result);
        transaction.onerror = () => reject(transaction.error);
        transaction.onabort = () => reject(transaction.error);
    });
}

export function savePhoto(key, blob) {
    return run('readwrite', (store) => store.put({blob, updatedAt: Date.now()}, key));
}

export function deletePhoto(key) {
    return run('readwrite', (store) => store.delete(key));
}

/**
 * Load all photos whose key starts with the given prefix.
 * Returns a Map of taskId -> Blob.
 */
export async function loadPhotos(prefix) {
    const db = await openDb();

    return new Promise((resolve, reject) => {
        const photos = new Map();
        // All keys from "prefix" up to "prefix" + the highest possible character
        const range = IDBKeyRange.bound(prefix, prefix + '\uffff');
        const request = db.transaction(STORE).objectStore(STORE).openCursor(range);

        request.onsuccess = () => {
            const cursor = request.result;

            if (!cursor) {
                resolve(photos);
                return;
            }

            photos.set(cursor.key.slice(prefix.length), cursor.value.blob);
            cursor.continue();
        };
        request.onerror = () => reject(request.error);
    });
}
